// services
import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

// stores
import { CredentialManagementStore } from "@retailer/stores/CredentialManagementStore";

// types
import type { DistributorCredentialData } from "@shared/types/DistributorCredential";

interface QueryFilters {
  order: string;
  direction: string;
  search: string;
}

const baseUrl = "/api/retailer/distributor_file_transfer_credentials";

const extractPagination = (response, pageNum) => {
  let perPage, totalEntries;
  for (let pair of response.headers.entries()) {
    const key = pair[0];
    switch (key) {
      case "x-pagination-limit":
        perPage = parseInt(pair[1]);
        break;
      case "x-pagination-entries":
        totalEntries = parseInt(pair[1]);
        break;
    }
  }

  return {
    page: Number(pageNum || 1),
    perPage: perPage,
    totalEntries: totalEntries,
  };
};

const errorCB = () => {
  CredentialManagementStore.update(state => ({
    ...state,
    loaded: true,
    failed: true,
  }));
};

export const getCredentials = async (pageNum: number, filters?: QueryFilters) => {
  CredentialManagementStore.update(state => ({
    ...state,
    loaded: false,
    failed: false,
    filters: {
      search: filters ? filters.search : "",
      order: filters ? filters.order : "",
      direction: filters ? filters.direction : "",
    },
  }));

  // request payload
  const urlParams = new URLSearchParams({
    page: pageNum.toString(),
    ...(filters && filters.order && { order: filters.order }),
    ...(filters && filters.direction && { direction: filters.direction }),
    ...(filters && filters.search && { search: filters.search }),
  });

  const requestData = {
    method: "GET",
    url: baseUrl + "?" + urlParams,
  };

  const response = await HttpPromiseWithEntireResponse(requestData);

  if (response.ok) {
    const json = await response.json();
    const pagination = extractPagination(response, pageNum);
    CredentialManagementStore.update(state => ({
      ...state,
      credentials: json,
      loaded: true,
      failed: false,
      pagination: pagination,
      filters: {
        order: (filters && filters.order) || "distributor.name",
        direction: (filters && filters.direction) || "ASC",
        search: (filters && filters.search) || "",
      },
    }));
  } else {
    errorCB();
  }
};

export const getDistributors = async () => {
  CredentialManagementStore.update(state => ({
    ...state,
    loaded: false,
    failed: false,
  }));

  const requestData = {
    method: "GET",
    url: baseUrl + "/distributors",
  };

  const response = await HttpPromiseWithEntireResponse(requestData);

  if (response.ok) {
    const json = await response.json();

    CredentialManagementStore.update(state => ({
      ...state,
      distributors: json,
      loaded: true,
      failed: false,
    }));
  } else {
    errorCB();
  }
};

export const addCredentials = (data: DistributorCredentialData, successCallback, errorCallback) => {
  HttpPromise({
    method: "POST",
    url: baseUrl,
    data,
  }).then(
    function success() {
      successCallback();
    },
    function error(res) {
      errorCallback(res);
    },
  );
};

export const removeCredentials = (id: number, successCallback, errorCallback) => {
  HttpPromise({
    method: "DELETE",
    url: baseUrl + `/${id}`,
  }).then(
    function success() {
      successCallback();
    },
    function error(res) {
      errorCallback(res);
    },
  );
};
